import { db } from 'src/config/firebase';
import _ from 'lodash';

const getPhotos = async (serviceId) => {
  try {
    const snapshot = await db
      .ref('Photos')
      .orderByChild('owner')
      .equalTo(serviceId)
      .get();
    const data = await snapshot.val();
    return _.values(data).reverse();
  } catch (error) {
    console.warn('Error fetching photos: ', error.message);
  }
};

export default getPhotos;
